import type { SVGProps } from 'react'
const SvgSyEdit = (props: SVGProps<SVGSVGElement>) => (
	<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width={24} height={24} {...props}>
		<g strokeLinejoin="round">
			<path
				d="M13.7 19.148a.75.75 0 0 0-.75.75.75.75 0 0 0 .75.75h6.376a.75.75 0 0 0 .75-.75.75.75 0 0 0-.75-.75z"
				opacity={0.4}
			/>
			<path
				fillRule="evenodd"
				d="M14.193 3.5a2.55 2.55 0 0 0-1.927.992l-8.29 10.576h-.001a2.24 2.24 0 0 0-.416 1.885l.724 3.115a.75.75 0 0 0 .74.58l3.196-.04a2.23 2.23 0 0 0 1.732-.858l8.29-10.574a2.55 2.55 0 0 0 .501-2.11c-.153-.697-.582-1.305-1.166-1.763l-1.39-1.09c-.585-.459-1.278-.731-1.993-.713m.04 1.5c.3-.008.671.114 1.027.393l1.39 1.09c.356.278.563.61.627.904.065.293.025.554-.218.865l-8.29 10.574a.73.73 0 0 1-.568.281l-2.594.034-.587-2.528v-.002a.73.73 0 0 1 .138-.619l8.287-10.574c.244-.31.487-.41.787-.418"
				clipRule="evenodd"
			/>
			<path
				d="M11.213 6.191a.75.75 0 0 0-.5.282.75.75 0 0 0 .127 1.052l4.795 3.76a.75.75 0 0 0 1.053-.129.75.75 0 0 0-.13-1.052l-4.792-3.758a.75.75 0 0 0-.553-.155"
				opacity={0.4}
			/>
		</g>
	</svg>
)
export default SvgSyEdit
